var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#9BCD9B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7306 15.3482L23.1918 9H21.8977L17.1557 14.5121L13.3683 9H9L14.7273 17.3352L9 23.9923H10.2942L15.3018 18.1714L19.3016 23.9923H23.6699L17.7303 15.3482H17.7306ZM15.958 17.4087L15.3777 16.5787L10.7605 9.97426H12.7483L16.4745 15.3042L17.0548 16.1342L21.8983 23.0623H19.9105L15.958 17.409V17.4087Z",
    fill: "#F3F5FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6699,
    height: 15,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterHover);
export default __webpack_public_path__ + "static/media/twitterHover.0839b71d7e5621456d9c4cfff8dd5a7c.svg";
export { ForwardRef as ReactComponent };